export enum SettlementStatusEnum {
  EXECUTED = "EXECUTED",
  FAILED = "FAILED",
  SUBROGATED = "SUBROGATED"
}
